import { render } from "./menuManage.vue?vue&type=template&id=124ad4a6&scoped=true"
import script from "./menuManage.vue?vue&type=script&lang=js"
export * from "./menuManage.vue?vue&type=script&lang=js"

import "./menuManage.vue?vue&type=style&index=0&id=124ad4a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124ad4a6"]])

export default __exports__